export const wyomingCountiesList = [
    'Albany',
    'Big Horn',
    'Campbell',
    'Carbon',
    'Converse',
    'Crook',
    'Fremont',
    'Goshen',
    'Hot Springs',
    'Johnson',
    'Laramie',
    'Lincoln',
    'Natrona',
    'Niobrara',
    'Park',
    'Platte',
    'Sheridan',
    'Sublette',
    'Sweetwater',
    'Teton',
    'Uinta',
    'Washakie',
    'Weston',
    ]